import CMSData from "aldoo-ra/CMS/cms-data"
import Typography from "aldoo-ra/Typography"
import parse from "html-react-parser"

// The CMS stores the terms as a *full* HTML document — `<!DOCTYPE>`,
// `<html>`, `<head>`, `<body>` and all. html-react-parser turns those
// into real DOM elements nested inside our React tree. iOS in-app
// Safari then applies its UA default `body { color: black }` to that
// nested <body>, which wins over the parent `text-text` Tailwind
// class. Desktop Safari/Chrome silently strip nested html/body, which
// is why only mobile rendered the body as dark text.
//
// Extract just the inner content of the CMS document (and strip any
// inline color the editor may add for similar reasons) so what we hand
// to react-parser is a plain fragment that inherits `text-text`.
function extractBody(html) {
    if (!html) return ""
    const m = html.match(/<body[^>]*>([\s\S]*?)<\/body>/i)
    let inner = m ? m[1] : html
    inner = inner
        .replace(/(\sstyle\s*=\s*"[^"]*?)\bcolor\s*:\s*[^;"]+;?/gi, "$1")
        .replace(/(\sstyle\s*=\s*"[^"]*?)\bbackground(-color)?\s*:\s*[^;"]+;?/gi, "$1")
        .replace(/\sstyle\s*=\s*"\s*"/gi, "")
    return inner
}

export default function TermsOfUsePage() {
  // CMSData: rendered with the page on the server (SSR prepass), localized
  const { data } = CMSData({ contentType: "ServiceText", match: { "content.id": "terms" } })
  const item = data[0]
  const html = item ? extractBody(item.text || item.content?.text || "") : null

  if (!html) return null

  return (
    <div className="relative overflow-x-clip bg-canvas min-h-screen">
      {/* Hero — shifted up so the transparent navbar sits over its gradient
          (matches the Privacy Policy / Features / Pricing pages). */}
      <section className="relative pt-28 md:pt-36 pb-10 text-center px-6">

        <div className="relative z-10 max-w-3xl mx-auto">
          <Typography variant="h1">
            Terms of Use
          </Typography>

          <Typography variant="body1_dim">
            The agreement that governs your use of Aldoo Snap
          </Typography>
        </div>
      </section>

      <div className="max-w-3xl mx-auto px-6 pb-20">
        {/* No @tailwindcss/typography in this project, so `prose` is a
            no-op — descendants inherit `text-text` from this wrapper
            unless the CMS HTML carries inline color (handled above).
            The arbitrary selectors below pin heading + link colors. */}
        <div className="max-w-none text-text leading-relaxed space-y-4 [&_h1]:text-text [&_h2]:text-text [&_h3]:text-text [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:mt-8 [&_h3]:text-xl [&_h3]:font-semibold [&_h3]:mt-6 [&_a]:text-primary [&_a:hover]:underline [&_strong]:text-text [&_li]:ml-6 [&_ul]:list-disc [&_ol]:list-decimal">
          {parse(html)}
        </div>
      </div>
    </div>
  )
}